const countryCodeToNameMap = {
  US: "United States",
  CA: "Canada",
  IN: "India",
  CH: "Switzerland",
  CO: "Colombia",
  MX: "Mexico",
  CL: "Chile",
  ZA: "South Africa",
  HR: "Croatia",
  AE: "United Arab Emirates",
  IL: "Israel",
  MY: "Malaysia",
  HK: "Hong Kong",
  GB: "United Kingdom",
  CN: "China",
};

const countryNameToCodeMap = Object.fromEntries(
  Object.entries(countryCodeToNameMap).map(([code, name]) => [name, code])
);

const buildStateMap = () => {
  const rawData = [
    { country: "US", stateName: "North Carolina", code: "NC" },
    { country: "US", stateName: "Missouri", code: "MO" },
    { country: "US", stateName: "New Mexico", code: "NM" },
    { country: "US", stateName: "Tennessee", code: "TN" },
    { country: "US", stateName: "New Hampshire", code: "NH" },
    { country: "US", stateName: "California", code: "CA" },
    { country: "US", stateName: "Arizona", code: "AZ" },
    { country: "US", stateName: "Massachusetts", code: "MA" },
    { country: "US", stateName: "Virginia", code: "VA" },
    { country: "US", stateName: "Washington", code: "WA" },
    { country: "US", stateName: "Florida", code: "FL" },
    { country: "US", stateName: "New York", code: "NY" },
    { country: "US", stateName: "Georgia", code: "GA" },
    { country: "US", stateName: "Illinois", code: "IL" },
    { country: "US", stateName: "New Jersey", code: "NJ" },
    { country: "US", stateName: "Connecticut", code: "CT" },
    { country: "US", stateName: "Pennsylvania", code: "PA" },
    { country: "US", stateName: "Texas", code: "TX" },
    { country: "US", stateName: "Oklahoma", code: "OK" },
    { country: "US", stateName: "Oregon", code: "OR" },
    { country: "US", stateName: "Rhode Island", code: "RI" },
    { country: "US", stateName: "Maryland", code: "MD" },
    { country: "US", stateName: "Michigan", code: "MI" },
    { country: "US", stateName: "Minnesota", code: "MN" },
    { country: "US", stateName: "Ohio", code: "OH" },
    { country: "US", stateName: "Kansas", code: "KS" },
    { country: "US", stateName: "Indiana", code: "IN" },
    { country: "US", stateName: "Montana", code: "MT" },
    { country: "US", stateName: "Colorado", code: "CO" },
    { country: "US", stateName: "Idaho", code: "ID" },
    { country: "US", stateName: "Alabama", code: "AL" },
    { country: "US", stateName: "Wyoming", code: "WY" },
    { country: "US", stateName: "Utah", code: "UT" },
    { country: "US", stateName: "Delaware", code: "DE" },
    { country: "US", stateName: "Hawaii", code: "HI" },
    { country: "US", stateName: "South Carolina", code: "SC" },
    { country: "US", stateName: "Alaska", code: "AK" },
    { country: "US", stateName: "West Virginia", code: "WV" },
    { country: "US", stateName: "Iowa", code: "IA" },
    { country: "US", stateName: "Nevada", code: "NV" },
    { country: "US", stateName: "Wisconsin", code: "WI" },
    { country: "US", stateName: "Nebraska", code: "NE" },
    { country: "US", stateName: "Arkansas", code: "AR" },
    { country: "US", stateName: "Tennessee", code: "TN" },
    { country: "US", stateName: "Louisiana", code: "LA" },
    { country: "US", stateName: "Kentucky", code: "KY" },
    { country: "US", stateName: "District of Columbia", code: "DC" },

    // Canada
    { country: "CA", stateName: "British Columbia", code: "BC" },
    { country: "CA", stateName: "Ontario", code: "ON" },
    { country: "CA", stateName: "Quebec", code: "QC" },
    { country: "CA", stateName: "Alberta", code: "AB" },
    { country: "CA", stateName: "Saskatchewan", code: "SK" },
    { country: "CA", stateName: "Nova Scotia", code: "NS" },

    // India
    { country: "IN", stateName: "Gujarat", code: "GJ" },
    { country: "IN", stateName: "Telangana", code: "TS" },
    { country: "IN", stateName: "Odisha", code: "OD" },
    { country: "IN", stateName: "Chhattisgarh", code: "CG" },
    { country: "IN", stateName: "Karnataka", code: "KA" },
    { country: "IN", stateName: "Tamil Nadu", code: "TN" },

    // Switzerland
    { country: "CH", stateName: "Neuchâtel", code: "NE" },
    { country: "CH", stateName: "Zürich", code: "ZH" },

    // Colombia
    { country: "CO", stateName: "Bogotá District Capital", code: "DC" },
    { country: "CO", stateName: "Valle del Cauca", code: "" },

    // Others
    { country: "MX", stateName: "Nuevo León", code: "NL" },
    {
      country: "MX",
      stateName: "Mexico (CDMX / Estado de México)",
      code: "MEX",
    },
    { country: "CL", stateName: "Metropolitana", code: "RM" },
    { country: "ZA", stateName: "Gauteng", code: "" },
    { country: "HR", stateName: "Zagreb", code: "" },
    { country: "AE", stateName: "Dubai", code: "" },
    { country: "IL", stateName: "Haifa", code: "" },
    { country: "IL", stateName: "Central", code: "" },
    { country: "MY", stateName: "Kuala Lumpur", code: "" },
    { country: "HK", stateName: "Eastern", code: "" },
    { country: "GB", stateName: "Greater London", code: "" },
    { country: "CN", stateName: "Beijing", code: "" },
  ];

  const map = {};
  rawData.forEach(({ country, stateName, code }) => {
    if (!map[country]) map[country] = {};
    if (stateName && code) {
      map[country][stateName] = code;
      map[country][code] = stateName;
    }
  });
  return map;
};

const stateMap = buildStateMap();

export const getCountryFullName = (identifier) => {
    if (!identifier) return "";
    return countryCodeToNameMap[identifier.toUpperCase()] || identifier;
};

export const getCountryCode = (fullName) => {
    if (!fullName) return "";
    return countryNameToCodeMap[fullName] || fullName;
};

export const getStateFullName = (stateIdentifier, countryCode) => {
    if (!stateIdentifier || !countryCode || !stateMap[countryCode]) {
        return stateIdentifier;
    }
    const countryStates = stateMap[countryCode];
    const mappedValue = countryStates[stateIdentifier];
    // Prefer the longer string (full name) if a mapping exists
    return (mappedValue && mappedValue.length > stateIdentifier.length) ? mappedValue : stateIdentifier;
};

export const getStateCode = (stateFullName, countryCode) => {
    if (!stateFullName || !countryCode || !stateMap[countryCode]) {
        return stateFullName;
    }
    const countryStates = stateMap[countryCode];
    const mappedValue = countryStates[stateFullName];
    // Prefer the shorter string (code) if a mapping exists
    return (mappedValue && mappedValue.length < stateFullName.length) ? mappedValue : stateFullName;
};